import {useEffect, useState} from 'react'
import {sharedEventBus} from '@/script/sharedEventBus.mjs'
import http from './http.mjs'
import {setToken} from './token.mjs'

const KEY = 'user'

const load = () => {
    const item = window.localStorage.getItem(KEY)

    if (! item) {
        return null
    }

    try {
        return JSON.parse(item)
    }
    catch (err) {
        console.err(err)
        return null
    }
}

const save = token => {
    if (token) {
        const item = JSON.stringify(token)
        window.localStorage.setItem(KEY, item)
    }
    else {
        window.localStorage.removeItem(KEY)
    }
}

export let user = load()

sharedEventBus.subscribe(KEY, e => user = e.data)

export const setUser = newUser => {
    if (newUser === user) {
        return
    }

    user = newUser
    save(user)
    sharedEventBus.publish(KEY, user)
}

export const useUser = () => {
    const [, setFlag] = useState(false)

    useEffect(
        () => {
            const onChange = () => setFlag(f => ! f)
            sharedEventBus.subscribe(KEY, onChange)
            return () => sharedEventBus.unsubscribe(KEY, onChange)
        },

        []
    )

    return user
}

// 密码登录
export const login = async ({password, userNo, captcha}) => {
    const {user, ...token} = await http.post(
        '/login/token',
        {password, userNo, captcha},
        {headers: {customHeader:'123'}},
    )

    setToken(token)
    setUser(user)
}

// 验证码登录
export const login2 = async ({phone, verifyCode, captcha}) => {
    const {user, ...token} = await http.post(
        '/login/token/verifyCode',
        {phone, verifyCode, captcha},
    )

    setToken(token)
    setUser(user)
}

// 验证码登录
export const codeLogin = async ({userNo, phone, verifyCode}) => {
    const {user, ...token} = await http.post(
        '/login/findPwd/verifyCode',
        {userNo, phone, verifyCode},
    )

    setToken(token)
    setUser(user)
}

export const logout = () => {
    setToken(null)
    setUser(null)
}

export const refreshPerm = async () => {
    const {
        projectFaMap,
        projectMenuMap,
        teamFaMap,
        teamMenuMap,
    } = await http.post(`/perm/refresh`, {pkid: user.pkid})

    setUser({
        ...user,
        projectFaMap,
        projectMenuMap,
        teamFaMap,
        teamMenuMap,
    })
}
